const state = {
  menu: [
    {
      label: '场景中心',
      value: 'changjing'
    },
    {
      label: '招聘',
      value: 'zhaopin'
    },
    {
      label: '员工',
      value: 'yuangong'
    },
    {
      label: '内推',
      value: 'neitui'
    },
    {
      label: '群发邮件',
      value: 'email'
    },
    {
      label: '工具',
      value: 'gongju'
    },
    {
      label: '标签',
      value: 'tag'
    },
    {
      label: '邮件归档',
      value: 'backup'
    },
    {
      label: '张贴',
      value: 'publish'
    },
    {
      label: '用户',
      value: 'user'
    },
    {
      label: 'image',
      value: 'image'
    },
    {
      label: '评优',
      value: 'evaluation'
    },
    {
      label: '项目管理',
      value: 'project'
    },
    {
      label: '录音管理',
      value: 'record'
    },
    {
      label: '离职文件',
      value: 'filebackup'
    },
    {
      label: '电话号码',
      value: 'mobile'
    }
  ]
}

export default {
  state
}
